module.exports = __webpack_public_path__ + "img/mobileBusinessLogo.bd1fbf3d.png";